import React, { useState, useEffect } from 'react';
import {
  Box,
  Stack
} from '@mui/material';
import ParticlesCanvas from "./components/ParticlesCanvas";
import { color } from './theme.js';
import { Front } from "./components/BusinessCard";

const BusinessCard = ({ profile }) => {

  return (
    <Front profile={profile} />
  );
}

const getProfile = async () => {
 const response = await fetch("/data/profile.json");
 return response.json();
};

export default function PortfolioPage() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getProfile().then((response) => {
      setProfile(response);
    });
  }, [])

  return (
    <Box
      display="flex"
      minHeight="100vh"
      bgcolor={ color.tangaroa[900] }
    >
      <Stack spacing={2} margin="0 auto" justifyContent="center" zIndex={1}>
        { profile && <BusinessCard profile={ profile }/> }
      </Stack>
      <ParticlesCanvas />
    </Box>
  )
}